// Imágenes de respaldo locales (base64 encoded placeholders)
// Estas imágenes se usan si las URLs externas fallan

export const LOCAL_BACKGROUNDS = [
  {
    id: 'gradient-1',
    style: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    title: 'Gradiente Púrpura'
  },
  {
    id: 'gradient-2', 
    style: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    title: 'Gradiente Rosa'
  },
  {
    id: 'gradient-3',
    style: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    title: 'Gradiente Azul'
  },
  {
    id: 'gradient-4',
    style: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
    title: 'Gradiente Verde'
  },
  {
    id: 'gradient-5',
    style: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    title: 'Gradiente Atardecer'
  }
];

// Función para verificar si una URL se carga correctamente
export const checkImageLoad = (url) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
};
